import { now } from "@@/shared/date-time/date-time";
import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";

type TicketSocketEventData<
    EventData extends Record<string, unknown> = Record<string, unknown>,
> = {
    createdAt: IsoAndUnixTimestamp;
} & (undefined extends EventData ? unknown : EventData);

const createTicketSocketEventData = <
    EventData extends Record<string, unknown> = Record<string, unknown>,
>(params: {
    eventData?: EventData;
}): TicketSocketEventData<EventData> => {
    const baseData: TicketSocketEventData = {
        createdAt: now(),
    };
    return {
        ...baseData,
        ...(params.eventData || {}),
    } as TicketSocketEventData<EventData>;
};

export { createTicketSocketEventData };
export type { TicketSocketEventData };
